import { NgModule } from '@angular/core';
import { LoaderTogglesClassDirective } from './loader-toggles-class.directive';

/** The LoaderDisablesFormGroupDirective module, used to improve tree shaking. */
@NgModule({
    declarations: [ LoaderTogglesClassDirective ],
    exports: [ LoaderTogglesClassDirective ]
})
export class LoaderTogglesClassModule { }
